import React from 'react'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import HeaderEG2023 from 'components/common/main-container/EG2023/header';
import HeaderDefault from 'components/common/main-container/default/Header';

export const HeaderCompetition = () => {

    const { mirs_competition } = useUrlFriendlyToParameters()

    let out = null
    switch (mirs_competition) {
        case 'EG2023':
            out = <HeaderEG2023 />
            break;
        default:
            out = <HeaderDefault />
    }

    return (<>{out}</>)


};

export default HeaderCompetition